import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, computed } from 'vue'
import {
  reportingStatusChipClasses,
  reportingStatusCountLabelKey,
  reportingStatusLabelKey,
} from '~/functions/reporting'


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusChip',
  props: {
    status: null,
    label: null,
    count: null
  },
  setup(__props: any) {

const props = __props as {
  status: string
  /** Override the default status label from this component's i18n. */
  label?: string
  /** When set, renders "{count} {label}" (aggregate progress). */
  count?: number
};



const { proxy } = getCurrentInstance()!

const resolvedLabel = computed(() => {
  if (props.label != null && props.label !== '') {
    return props.label
  }
  const key =
    props.count != null
      ? reportingStatusCountLabelKey(props.status)
      : reportingStatusLabelKey(props.status)
  return String(proxy.$t(key))
})

return { __sfc: true,props, proxy, resolvedLabel, reportingStatusChipClasses }
}

})